
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import WKT from 'ol/format/WKT';

import { PanelSectionTitle } from '../../core';

import { getTempFeature } from '../../map';

import {
    ParameterListWithGeom,
    useSearchDefinition
} from '../../search';

import usePrintDefinition from '../hooks/usePrintDefinition';
import useReport from '../hooks/useReport';
import useReportDefinition from '../hooks/useReportDefinition';
import { getUi } from '../reducers'
import { getReport } from '../reducers/definition'
import { getActions } from '../sagas';

import {
    getIsValid,
    getParamValues,
    getParamsForReport,
    getReportId
} from '../reducers/ui'

import PrintInternalPanel from './PrintInternalPanel';

const PrintForm = ({
    onSelectReport,
    onSetGeomCondition,
    onSetGeometry,
    onSetIsGeoActive,
    onSetIsValid,
    onSetParamValue
}) => {

    const classNames = mergeStyleSets({
        PrintForm: {
        },
        reports: {
            paddingBottom: 8
        }
    });

    const dispatch = useDispatch();
    const printActions = getActions(dispatch);

    const searchDefinition = useSearchDefinition();
    const printDefinition = usePrintDefinition();
    const reportDefinition = useReportDefinition();

    const isValid = useSelector(state => getIsValid(getUi(state.print)));
    const paramValues = useSelector(state => getParamValues(getUi(state.print)));
    const paramsForReport = useSelector(state => getParamsForReport(getUi(state.print)));
    const reportId = useSelector(state => getReportId(getUi(state.print)));
    const report = useReport(reportId);

    const tempFeature = useSelector(state => getTempFeature(state.map.map));

    React.useEffect(() => {
        if (onSetGeomCondition) {
            let format = new WKT();
            let geom = tempFeature ? format.writeGeometry(tempFeature.getGeometry()) : null;
            onSetGeomCondition(
                geom, 'st_intersects'
            );
        }
    }, [tempFeature]);

    const getReportsOptions = () => {
        return reportDefinition
            .filter(item => (item.hidden !== true))
            .map(item => {
                return {
                    key: item.id,
                    text: item.title
                };
            });
    }

    const getDefinitionForGeneratePolygon = () => {
        return (searchDefinition.searchDefinition).reduce((previous, current) => {
            return (!previous && (current.hidden && current.subType === 'GeneratePolygon'))
                ? current
                : previous;
        }, null);
    }

    const handleClickGenerate = (evt) => {
        if (report) {
            let params = report.params.reduce((previous, current) => {
                return {
                    ...previous,
                    [current.id]: paramsForReport[current.id] || current.defaultValue || ''
                };
            }, {});

            printActions.generateReport(report, JSON.stringify(params));
        }
    }

    const handleChangeReport = (evt, option, index, value) => {
        if (onSelectReport) {
            onSelectReport(option.key, option.reportType);
        }
        handleSetIsValid(false);
    }

    const handleSetIsValid = (valid) => {
        if (onSetIsValid) {
            onSetIsValid(valid);
        }
    }

    const handleChangeParamValue = (paramId, value) => {
        if (onSetParamValue) {
            onSetParamValue(paramId, value);
        }
        // ToDo:
        handleSetIsValid(true);
    }

    const renderPrintFormContent = () => {
        let report = getReport(printDefinition, reportId);
        if (report) {
            if (report.type === 'INTERNAL') {
                return renderPrintFormContentInternal();
            } else {
                return renderPrintFormContentParameters(report);
            }
        }
    }

    const renderPrintFormContentInternal = () => {
        return (
            <PrintInternalPanel />
        );
    }

    const renderPrintFormContentParameters = (report) => {
        return (
            <React.Fragment>
                <Stack.Item align="stretch">
                    <ParameterListWithGeom
                        generatePolygonDefinition={getDefinitionForGeneratePolygon()}
                        params={report.params}
                        paramValues={paramValues}
                        tempFeature={tempFeature}
                        onChangeValue={handleChangeParamValue}
                        onSetGeometry={onSetGeometry}
                        onSetIsGeoActive={onSetIsGeoActive}
                            />
                </Stack.Item>
                <Stack.Item align="end">
                    <PrimaryButton
                        onClick={handleClickGenerate}
                        text="Tisknout"
                        disabled={!isValid}
                    />
                </Stack.Item>
            </React.Fragment>
        );
    }

    return (
        <Stack className={classNames.PrintForm} tokens={{childrenGap: 4}} >
            <Stack.Item align="stretch" className={classNames.reports}>
                <PanelSectionTitle title="Co chcete vygenerovat" />
                <ComboBox
                    selectedKey={reportId}
                    options={getReportsOptions()}
                    onChange={handleChangeReport}
                />
            </Stack.Item>

            {renderPrintFormContent()}

        </Stack>
    );
}

export default PrintForm;
